/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Kanban_Unknown_OwnerInputs */

const en_explorer_kanban_unknown_owner = /** @type {(inputs: Explorer_Kanban_Unknown_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const fr_explorer_kanban_unknown_owner = /** @type {(inputs: Explorer_Kanban_Unknown_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inconnu`)
};

const de_explorer_kanban_unknown_owner = /** @type {(inputs: Explorer_Kanban_Unknown_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannt`)
};

const it_explorer_kanban_unknown_owner = /** @type {(inputs: Explorer_Kanban_Unknown_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconosciuto`)
};

const ru_explorer_kanban_unknown_owner = /** @type {(inputs: Explorer_Kanban_Unknown_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестный`)
};

const es_explorer_kanban_unknown_owner = /** @type {(inputs: Explorer_Kanban_Unknown_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconocido`)
};

const zh_cn2_explorer_kanban_unknown_owner = /** @type {(inputs: Explorer_Kanban_Unknown_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知`)
};

const ja_explorer_kanban_unknown_owner = /** @type {(inputs: Explorer_Kanban_Unknown_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知`)
};

const hi_explorer_kanban_unknown_owner = /** @type {(inputs: Explorer_Kanban_Unknown_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अज्ञात`)
};

const pt_pt2_explorer_kanban_unknown_owner = /** @type {(inputs: Explorer_Kanban_Unknown_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconhecido`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Explorer_Kanban_Unknown_OwnerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_unknown_owner = /** @type {((inputs?: Explorer_Kanban_Unknown_OwnerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Unknown_OwnerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_kanban_unknown_owner(inputs)
	if (locale === "de") return de_explorer_kanban_unknown_owner(inputs)
	if (locale === "it") return it_explorer_kanban_unknown_owner(inputs)
	if (locale === "ru") return ru_explorer_kanban_unknown_owner(inputs)
	if (locale === "es") return es_explorer_kanban_unknown_owner(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_kanban_unknown_owner(inputs)
	if (locale === "ja") return ja_explorer_kanban_unknown_owner(inputs)
	if (locale === "hi") return hi_explorer_kanban_unknown_owner(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_kanban_unknown_owner(inputs)
	return en_explorer_kanban_unknown_owner(inputs)
});